"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggletipCloseButtonStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _createFocusRingStyles = require("../../../util/createFocusRingStyles");
var _clickable = require("../../clickable");
var _tooltipTheme = require("../../tooltip/tooltipTheme");
const ToggletipCloseButtonStyled = (0, _styled.default)(_clickable.Clickable)`
    top: 4px;
    right: 4px;

    height: 24px;
    width: 24px;

    color: inherit;

    &:hover {
        color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _tooltipTheme.tooltipTheme.background(themeMode);
}};
        background-color: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _tooltipTheme.tooltipTheme.textColor.body(themeMode);
}};
        border-radius: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _tooltipTheme.tooltipTheme.borderRadius(themeMode);
}};
    }

    ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return (0, _createFocusRingStyles.createFocusRingStyles)({
    theme: themeMode,
    componentBorderWidth: 0,
    componentRadius: 4,
    gap: 0,
    position: "absolute",
    colorOverride: "currentColor",
    innerColorOverride: "transparent"
  });
}}
`;
exports.ToggletipCloseButtonStyled = ToggletipCloseButtonStyled;
//# sourceMappingURL=ToggletipCloseButtonStyled.js.map